/* ----------------- Component Imports --------------- */
import ScrollContainer from "@memorang/ui/src/components/ScrollContainer";

/* ----------------- UI Imports --------------- */
import Box from "@memorang/ui/src/components/Box";

import { ComingSoonEmptyState } from "components/ComingSoonEmptyState";

const DetailArticleSupplementalyView = () => {
	return (
		<ScrollContainer>
			<Box padding={16}>
				<ComingSoonEmptyState view="article-supplementaly" />
			</Box>
		</ScrollContainer>
	);
};

export default DetailArticleSupplementalyView;
